<template>
  <DisplayContainer label=" Human Tasks">
    <template>
      <v-data-table
        :headers="[
          {
            text: 'Vertragsnummer',
            align: 'start',
            value: 'contractId'
          },
          {
            text: 'Human Task',
            value: 'humanTaskName',
            sortable: false
          }
        ]"
        :items="humanTaskTableData"
        item-key="taskId"
        :loading="dataLoading"
        loading-text="Human Tasks werden geladen..."
        no-data-text="Keine offenen Human Tasks vorhanden."
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        dense
        hide-default-footer
        class="elevation-1 margin-top-1"
      >
        <template v-slot:[`item.humanTaskName`]="{ item }">
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <router-link
                    v-if="item.taskUrl"
                    :to="item.taskUrl"
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.humanTaskName }}
                  </router-link>
                  <span
                    v-else
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.humanTaskName }}
                  </span>
                </span>
              </template>
              <span>
                Dieser Prozess befindet sich in einer Aufgabe die bearbeitet
                werden muss, damit der Prozess weiterlaufen kann.
              </span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </template>
  </DisplayContainer>
</template>

<script>
import { HTTP } from '@/main/httpClient.js';
import DisplayContainer from '@/components/elements/DisplayContainer.vue';
export default {
  name: 'DisplayHumanTasks',
  components: {
    DisplayContainer
  },
  props: {
    contractData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    sortBy: 'contractId',
    sortDesc: true,
    humanTaskTableData: [],
    dataLoading: true
  }),
  watch: {
    contractData: {
      handler() {
        this.loadHumanTasks();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    loadHumanTasks() {
      this.humanTaskTableData = [];
      this.dataLoading = true;
      const contractIds = Object.keys(this.contractData);

      if (contractIds.length === 0) return;
      HTTP.get(`/taskList/humanTasks?contractIds=${contractIds.join(',')}`)
        .then((res) => {
          this.humanTaskTableData = res.data.map((entry) => ({
            contractId: entry.cacheData.contractId,
            humanTaskName: entry.taskDto.name,
            taskUrl: this.$router.resolve({
              name: 'Aufgabe',
              params: { id: entry.taskDto.id }
            }).href,
            taskId: entry.taskDto.id
          }));
        })
        .catch(() => {
          this.humanTaskTableData = [];
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }
};
</script>

<style></style>
